import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { useReduxLoading } from '@core/hooks';
import { cancelarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmpresaModais } from '../EmpresaModais';
import { Content } from './content';
import { planoComercialStyles } from './styles/Styles';

const ModalAlteracaoPlanoComercial = () => {
  const [modal, setModal] = useContext(GlobalContext).modal;
  const [loading, setLoading] = useState(false);
  const user = useSelector(({ auth }) => auth.user);

  const dispatch = useDispatch();
  useReduxLoading(loading);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const classes = planoComercialStyles();

  const handleSubmit = (values) => {
    setLoading(false);
    try {
      eventReactGA('Empresa', 'Solicitar alteração do plano comercial');
      empresaApi.enviarEmailAlteracaoPlanoComercial(values);
      showSuccess('E-mail enviado com sucesso');
      close();
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const registro = {
    comentario: '',
    nomeUsuario: user.data.displayName[0],
  };

  const formik = useFormik({
    initialValues: registro,
    onSubmit: handleSubmit,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const close = () => {
    formik.resetForm(registro);
    setModal('');
  };

  const handleCloseModal = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  return (
    <SimpleDialog
      open={modal === EmpresaModais.alteracaoPlanoComercial}
      container={classes.Container}
      onClose={handleCloseModal}
      paperClass={classes.PaperClass}
    >
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Alteração do plano comercial',
            toolbar: (
              <>
                <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Enviar
                </SaveButton>
              </>
            ),
          }}
          content={<Content />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ModalAlteracaoPlanoComercial;
